<template>
  <div
    class="modal no-stacking"
    id="DeleteAccountUnableToDeleteModal"
    data-test-hook="modal-title-delete-account-unable-to-delete-modal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div v-if="getStoreType() === 'Google'">
          <div class="modal-header pb-0 pt-0">
            <h2 class="modal-title" data-test-hook="modal-heading-delete-account-unable-to-delete-modal">
              <i class="far fa-circle-exclamation colorOrange mr-1 mt-3"></i>
              {{ $t('xActionRequiredHeader') }}
            </h2>
            <button
              class="btn btn-icon-button btn-icon-button--gray"
              @click="closeModal()"
              data-test-hook="x-close-button-delete-account-unable-to-delete-modal"
            >
              <i class="fas fa-times" />
            </button>
          </div>
          <div class="modal-body">
            <div align-h="around" class="row">
              <div class="col text-break" data-test-hook="modal-body1-text-delete-account-unable-to-delete-modal">
                {{ $t('xActiveGoogleSubscription') }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary span9 btn-block"
              @click="closeModal()"
              data-test-hook="done-button-delete-account-unable-to-delete-modal"
            >
              {{ $t('xDone') }}
            </button>
          </div>
        </div>
        <div v-if="getStoreType() === 'Apple'">
          <div class="modal-header pb-0 pt-0">
            <h2 class="modal-title" data-test-hook="modal-heading-delete-account-unable-to-delete-modal">
              <i class="far fa-circle-exclamation colorOrange mr-1 mt-3"></i>
              {{ $t('xActionRequiredHeader') }}
            </h2>
            <button
              class="btn btn-icon-button btn-icon-button--gray"
              @click="closeModal()"
              data-test-hook="x-close-button-delete-account-unable-to-delete-modal"
            >
              <i class="fas fa-times" />
            </button>
          </div>
          <div class="modal-body">
            <div align-h="around" class="row">
              <div class="col text-break" data-test-hook="modal-body1-text-delete-account-unable-to-delete-modal">
                {{ $t('xActiveAppleSubscription') }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary span9 btn-block"
              @click="closeModal()"
              data-test-hook="done-button-delete-account-unable-to-delete-modal"
            >
              {{ $t('xDone') }}
            </button>
          </div>
        </div>
        <div v-if="getStoreType() === 'Web'">
          <div class="modal-header pb-0 pt-0">
            <h2 class="modal-title" data-test-hook="modal-heading-delete-account-unable-to-delete-modal">
              <i class="far fa-circle-exclamation colorOrange mr-1 mt-3"></i>
              {{ $t('xActiveSubscriptionHeader') }}
            </h2>
            <button
              class="btn btn-icon-button btn-icon-button--gray"
              @click="closeModal()"
              data-test-hook="x-close-button-delete-account-unable-to-delete-modal"
            >
              <i class="fas fa-times" />
            </button>
          </div>
          <div class="modal-body">
            <div align-h="around" class="row">
              <div class="col text-break" data-test-hook="modal-body1-text-delete-account-unable-to-delete-modal">
                {{ $t('xYouHaveSubscriptionText', { planName: this.deleteAccountUnableToDeleteModalInfo.planName }) }}
              </div>
            </div>
            <div align-h="around" class="row mt-4 mb-0">
              <div class="col" data-test-hook="modal-body2-text-delete-account-unable-to-delete-modal">
                {{ $t('xAreYouSureText') }}
              </div>
            </div>
          </div>
          <div class="modal-footer pr-5">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeModal()"
              data-test-hook="keep-plan-button-delete-account-unable-to-delete-modal"
            >
              {{ $t('xKeepPlan') }}
            </button>
            <button
              class="btn btn-primary"
              @click="cancelPlan()"
              data-test-hook="cancel-plan-button-delete-account-unable-to-delete-modal"
            >
              {{ $t('xYesCancelPlan') }}
            </button>
          </div>
        </div>
        <div v-if="getStoreType() === 'Legacy'">
          <div class="modal-header pb-0 pt-0">
            <h2 class="modal-title" data-test-hook="modal-heading-delete-account-unable-to-delete-modal">
              <i class="far fa-circle-exclamation colorOrange mr-1 mt-3"></i>
              {{ $t('xActiveSubscriptionHeader') }}
            </h2>
            <button
              class="btn btn-icon-button btn-icon-button--gray"
              @click="closeModal()"
              data-test-hook="x-close-button-delete-account-unable-to-delete-modal"
            >
              <i class="fas fa-times" />
            </button>
          </div>
          <div class="modal-body">
            <div align-h="around" class="row">
              <div class="col" data-test-hook="modal-body1-text-delete-account-unable-to-delete-modal">
                {{
                  $t('xYouHaveSubscriptionText', { planName: this.deleteAccountUnableToDeleteModalInfo.legacyPlanName })
                }}
              </div>
            </div>
            <div align-h="around" class="row mt-4 mb-0">
              <div class="col" data-test-hook="modal-body2-text-delete-account-unable-to-delete-modal">
                {{ $t('xAreYouSureText') }}
              </div>
            </div>
          </div>
          <div class="modal-footer pr-5">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeModal()"
              data-test-hook="keep-plan-button-delete-account-unable-to-delete-modal"
            >
              {{ $t('xKeepPlan') }}
            </button>
            <button
              class="btn btn-primary"
              @click="cancelPlan()"
              data-test-hook="cancel-plan-button-delete-account-unable-to-delete-modal"
            >
              {{ $t('xYesCancelPlan') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Constants from '@/constants'

const SubscriptionStoreTypes = {
  WEB: 'Web',
  GOOGLE: 'Google',
  APPLE: 'Apple'
}

export default {
  components: {},
  props: ['deleteAccountUnableToDeleteModalInfo'],
  methods: {
    closeModal() {
      document.getElementById('DeleteAccountUnableToDeleteModal').style.display = 'none'
    },
    cancelPlan() {
      this.$router.push({ name: 'settingsSubscriptions', query: { managePlan: true } })
    },
    getStoreType() {
      if (
        this.deleteAccountUnableToDeleteModalInfo.store ===
        Object.values(Constants.SubscriptionStoreTypes).indexOf('Web')
      ) {
        return SubscriptionStoreTypes.WEB
      } else if (
        this.deleteAccountUnableToDeleteModalInfo.store ===
        Object.values(Constants.SubscriptionStoreTypes).indexOf('Apple')
      ) {
        return SubscriptionStoreTypes.APPLE
      } else if (
        this.deleteAccountUnableToDeleteModalInfo.store ===
        Object.values(Constants.SubscriptionStoreTypes).indexOf('Google')
      ) {
        return SubscriptionStoreTypes.GOOGLE
      } else if (this.deleteAccountUnableToDeleteModalInfo.hasLegacySub) {
        return 'Legacy'
      }
    }
  }
}
</script>
<style scoped></style>
